import { types } from "mobx-state-tree"

export const DoctorProfessional = types
    .model({
        professionalId: types.optional(types.number, 0),
        professionalName: types.optional(types.string, "")
    }).actions(self => ({

    }))